import React, { useEffect, useState } from 'react';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Title from '../../../components/Title';
import { headerDataMission } from "../../../data/modules/mission-header";
import { Grid, Paper, Typography } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import Spacer from '../../../components/Spacer';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
    content: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      alignContent: "center",
     justifyContent: "center",
      flexDirection: "row",
    //   maxWidth: "80%",
      textAlign: "center",
      elevation: 0,
    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
      elevation: 0,
      margin: 'auto',
      maxWidth: '90%',
    },
    }));

export default function MissionPlaningSelect() {
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        setRows([
            { id: 1, title: 'Mission 1', objet: 'Objet 1', destination: 'Destination 1', depart: '2021-10-01', retour: '2021-10-10', action: 'Action 1' },
            { id: 2, title: 'Mission 2', objet: 'Objet 2', destination: 'Destination 2', depart: '2021-10-02', retour: '2021-10-11', action: 'Action 2' },
            { id: 3, title: 'Mission 3', objet: 'Objet 3', destination: 'Destination 3', depart: '2021-10-03', retour: '2021-10-12', action: 'Action 3' },
            { id: 4, title: 'Mission 4', objet: 'Objet 4', destination: 'Destination 4', depart: '2021-10-04', retour: '2021-10-13', action: 'Action 4' },
            { id: 5, title: 'Mission 5', objet: 'Objet 5', destination: 'Destination 5', depart: '2021-10-05', retour: '2021-10-14', action: 'Action 5' },
            { id: 6, title: 'Mission 6', objet: 'Objet 6', destination: 'Destination 6', depart: '2021-10-06', retour: '2021-10-15', action: 'Action 6' },
            { id: 7, title: 'Mission 7', objet: 'Objet 7', destination: 'Destination 7', depart: '2021-10-07', retour: '2021-10-16', action: 'Action 7' },
            { id: 8, title: 'Mission 8', objet: 'Objet 8', destination: 'Destination 8', depart: '2021-10-08', retour: '2021-10-17', action: 'Action 8' },
            { id: 9, title: 'Mission 9', objet: 'Objet 9', destination: 'Destination 9', depart: '2021-10-09', retour: '2021-10-18', action: 'Action 9' },
        ]);
    }
    , []);

    const classes = useStyles();
    const columns = [
        { field: 'title', headerName: 'Titre', width: 250 },
        { field: 'objet', headerName: 'Objet', width: 250 },
        { field: 'destination', headerName: 'Destination', width: 200 },
        { field: 'depart', headerName: 'Date de départ', width: 250 },
        { field: 'retour', headerName: 'Date de retour', width: 250 },
        { field: 'action', headerName: 'Action', width: 200 },
        ];


    return (
        <MainContainer {...headerDataMission}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Spacer y={2} />
        <Paper className={classes.paper} >
        <Grid container spacing={3} className={classes.content}>
        <Grid item xs={12} >
            <Typography variant="p" gutterBottom>
            Veuillez choisir la mission pour laquelle vous souhaitez élaborer l'Ordre de Mission.
            </Typography>
        <div style={{ height: 500, width: '100%' }}>
          <DataGrid rows={rows} columns={columns} 
           pageSize={7}
           rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          onRowDoubleClick={() => navigate("/mission/om/add")}
          />
        </div>
        </Grid>
        </Grid>
        </Paper>
     </MainContainer>
    )
}
